import React, { useMemo, useState } from 'react'
import { Box, Button, Card, ColouredTag, EmptyBox, Heading, Icon, Input, SimpleGrid, Stack, Text } from '@/components/lib'
import { FaPlus } from 'react-icons/fa'

import useStore from '../../../store'
import utils from '../../../utils/utils'

import GroupCreator from '../../includes/GroupCreator'

export default function Groups ({ onViewParticipants }) {
  const { user, trial, groups, setParticipantsTableFilters } = useStore()
  const [filterTerm, setFilterTerm] = useState('')

  const sortedGroups = useMemo(() => {
    return (groups || []).slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''))
  }, [groups])

  const filteredGroups = useMemo(() => {
    const term = (filterTerm || '').trim().toLowerCase()
    if (!term) return sortedGroups
    return sortedGroups.filter(g => {
      const name = (g?.name || '').toLowerCase()
      const description = (g?.description || '').toLowerCase()
      return name.includes(term) || description.includes(term)
    })
  }, [sortedGroups, filterTerm])

  const canManage = utils.canManageTrial(user, trial)

  function viewGroupInParticipants (groupId) {
    setParticipantsTableFilters({
      groupIncludeIds: [groupId],
      groupExcludeIds: [],
      groupNoneFilter: null,
      page: 1
    })
    onViewParticipants && onViewParticipants()
  }

  return (
    <Stack gap={5}>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Box>
          <Heading size='md'>Groups</Heading>
          <Text fontSize='md' color='fg.muted'>Use groups as tags to organise participants into study arms, cohorts, or just to assign labels.</Text>
        </Box>
        {canManage && (
          <GroupCreator
            trial={trial}
            trigger={<Button colorPalette='primary'><Icon as={FaPlus} /> Create group</Button>}
          />
        )}
      </Stack>

      <Stack direction='row' alignItems='center' justifyContent='space-between' gap={3}>
        <Input
          value={filterTerm}
          onChange={e => setFilterTerm(e.target.value)}
          placeholder='Filter groups...'
          maxW='420px'
          size='sm'
        />
      </Stack>

      {sortedGroups.length === 0
        ? (
          <EmptyBox
            icon='people'
            title='No groups have been created yet'
            description='Create a group to begin organising participants.'
          />
          )
        : filteredGroups.length === 0
          ? (
            <EmptyBox
              icon='notfound'
              title='No groups match your filter'
              description='Try a different search term.'
            />
            )
          : (
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={4}>
              {filteredGroups.map(g => (
                <Card key={g._id} variant='outline' gap={3}>
                  <Box>
                    <ColouredTag colour={g.colour}>{g.name}</ColouredTag>
                  </Box>

                  <Stack direction='row' justifyContent='end'>
                    <Button size='sm' variant='outline' onClick={() => viewGroupInParticipants(g._id)}>
                      View participants
                    </Button>
                    {canManage && (
                      <GroupCreator
                        trial={trial}
                        group={g}
                        trigger={<Button size='sm' colorPalette='primary'>Edit</Button>}
                      />
                    )}
                  </Stack>
                </Card>
              ))}
            </SimpleGrid>
            )}
    </Stack>
  )
}
